import { 
    getAuth,
    createUserWithEmailAndPassword,
    signOut,
    signInWithEmailAndPassword,
    updateProfile
 } from "firebase/auth";
 import { getFirestore } from "firebase/firestore"
 import { doc, setDoc, getDoc, updateDoc,collection, get, collectionGroup, where, query, onSnapshot,getDocs  } from "firebase/firestore";
 import { getMessaging, getToken } from "firebase/messaging";



const state = () => ({
    logged_in: false,
    name: '',
    user: null,
    profile: null,
    friends: []
})

const getters = {
    is_logged_in: () => {
        return state.logged_in
    },
    get_name: (state) => {
        if (!state.name){ return ''}
        return state.name + ` (${state.logged_in ? "Logged In" : "Logged Out"})`
    }
}

let register_service_workrer_notifications = (context, profile)=>{
    getToken(getMessaging(), { vapidKey: 'BGuoDlMmfQ_GaoyABcbHNPuaR9RCqXltAZnQOa6KGEFK09mYXBj43PZVVevs4SVph38MAfs5zkdrRqkYFESVZe8' }).then((currentToken) => {
        if (currentToken && profile) {
            if (!profile.tokens) profile.tokens = [];

            if ( profile.tokens && !profile.tokens.find(t=>t==currentToken)){
                profile.tokens.push(currentToken)
                updateDoc(doc(getFirestore(), "users", profile.id), profile)
            }
        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
    }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
}

const actions = {
    async log_in (context, {email, password}){
        if ( !email || !password ){
            return false;
        }
        const auth = getAuth();
        const db = getFirestore()
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        context.commit('set_logged_in', true);

        const docSnap = await getDoc(doc(db, "users", userCredential.user.uid));
        let profile = null
        if (docSnap.exists()) {
            profile = docSnap.data()
            profile.id = userCredential.user.uid
            context.commit('set_profile', profile)
        }

        register_service_workrer_notifications(context, profile)
        
        
        return userCredential;
    },
    async register(context, {email, password, name}){
        const db = getFirestore()
        const auth = getAuth();
            
        return createUserWithEmailAndPassword(auth, email, password)
        .then(async (userCredential) => {
            let user_id = userCredential.user.uid
            
            await setDoc(doc(db, "users", user_id),{
                id: user_id,
                email,
                name,
                created_at: new Date()
            })

            const docSnap = await getDoc(doc(db, "users", userCredential.user.uid));
            let profile = null
            if (docSnap.exists()) {
                profile = docSnap.data()
                context.commit('set_profile', profile)


                let public_profile = {
                    user_id: user_id,
                    email,
                    name,
                }
                await setDoc(doc(db, "users", user_id, "public_profile", user_id ), public_profile)
            }

            register_service_workrer_notifications(context, profile)

            context.commit('set_logged_in', true)
            return userCredential;
        })
        .catch(error => {
            console.log(error)
            // const errorCode = error.code;
            // const errorMessage = error.message;
        });
    },
    log_out(context){
        const auth = getAuth();
        return signOut(auth).then(()=>{
            context.commit('set_logged_in', false)
            context.commit('log_out' )
        })
    },
    async search(context, params){
        const db = getFirestore()
        let q = query( collectionGroup(db, 'public_profile'), where( 'user_id', 'in', params.users))
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());
        });
    },
    async search_email(context, params){
        const db = getFirestore()
        let q = query( collectionGroup(db, 'public_profile'), where( 'email', '==', params.email))
        const querySnapshot = await getDocs(q);
        let users = []
        querySnapshot.forEach((doc) => {
            users.push(doc.data())
            console.log(doc.id, " => ", doc.data());
        });
        return users;
    },
    async get_friends(context, {user_ids}){
        const db = getFirestore()

        let to_get = user_ids.filter(id=>
            !(context.state.friends || []).some(f=>f.user_id === id)
        )
        if ( !to_get.length ){
            return true
        }
        console.log("getting friends");
        let q = query( collectionGroup(db, 'public_profile'), where( 'user_id', 'in', to_get))
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            context.commit('add_friend', doc.data() )
        });
    }
}

const mutations = {
    set_name( state, name ){
        state.name = name
    },
    set_logged_in( state, logged_in = true ) {
        state.logged_in = logged_in
    },
    set_user( state, user ){
        state.user = user
    },
    set_profile( state, profile ){
        state.profile = profile
    },
    add_friend( state, friend ){
        if ( !state.friends ){
            state.friends = []
        }
        state.friends.push(friend)
    },
    log_out( state ){
        state.friends = null;
        state.name = null;
        state.user = null;
        state.logged_in = null;
        state.profile = null;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  }